export enum ContactGender {
	male    = 'M',
	female  = 'F',
	neutral = 'N',
	other   = 'O'
};

export class Contact {
	gender : ContactGender = ContactGender.neutral;
	companyName : string | null = null;
	firstName : string | null = null;
	lastName : string | null = null;
	countryCode : string | null = null;
	state : string | null = null;
	postcode : string | null = null;
	city : string | null = null;
	address : string | null = null;
	addressComplement : string | null = null;
	email : string | null = null;
	phone : string | null = null;
	mobilePhone : string | null = null;
	metadata : string | null = null;

	set(key : string, value? : any) {
		switch (key) {
			case 'gender':
			{
				if (value && (![ 'M', 'F', 'N', 'O' ].includes(value))) {
					throw new Error;
				}
				break;
			}
			case 'companyName':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'firstName':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'lastName':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'countryCode':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'state':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'postcode':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'city':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'address':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'addressComplement':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'email':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'phone':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'mobilePhone':
			{
				if (value && (typeof value !== 'string')) {
					throw new Error;
				}
				break;
			}
			case 'metadata':
			{
				break;
			}
			default:
				throw new Error('Unknown key!');
		}
		this[ key ] = value;
	}
};
